var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageBubbleTail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.77 -119H23.468C16.782 -119 14.358 -118.304 11.913 -116.997C9.49723 -115.718 7.52172 -113.743 6.243 -111.327C4.935 -108.882 4.239 -106.457 4.239 -99.771V-10.229C4.239 -3.543 4.935 -1.119 6.243 1.326C7.52172 3.74177 9.49723 5.71728 11.913 6.996C14.356 8.305 16.78 9 23.467 9H299.771C306.457 9 308.881 8.304 311.326 6.997C313.742 5.71828 315.717 3.74277 316.996 1.327C318.304 -1.118 319 -3.543 319 -10.229V-99.771C319 -106.457 318.304 -108.881 316.997 -111.326C315.718 -113.742 313.743 -115.717 311.327 -116.996C308.881 -118.305 306.456 -119 299.77 -119Z",
    fill: "#EBECFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.238 -10C19.238 0.493 10.732 9 0.238 9H0C0.948072 8.07453 1.7472 7.00791 2.369 5.838C3.589 3.556 4.239 1.14 4.239 -4.178V-10H19.239H19.238Z",
    fill: "#EBECFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 319,
    height: 128,
    fill: "white",
    transform: "translate(0 -119)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBubbleTail);
export default __webpack_public_path__ + "static/media/message-bubble-tail.8e120147.svg";
export { ForwardRef as ReactComponent };